import React from "react";
import Style from "../../styles/js/StyleABMCategories.js";
import Typography from "@material-ui/core/Typography";

export default function Header() {
  const style = Style();

  return (
    <div className={style.header}>
      <Typography variant="h6" gutterBottom className={style.itemHeader}>
        ADMINISTRADOR DE CATEGORIAS{" "}
      </Typography>
      <Typography variant="h8" gutterBottom className={style.itemHeader}>
        Desde esta pantalla podrá modificar las categorias y subcategorias
        disponibles para el envío de notificaciones.{" "}
      </Typography>
      <Typography variant="h8" gutterBottom className={style.itemHeader}>
        Para ver las subcategorias disponibles, haga click en cada categoria.{" "}
      </Typography>
      <Typography variant="h8" gutterBottom className={style.itemHeader}>
        Para activar o desactivar una categoria, presione en el checkbox situado
        junto al nombre de la misma.
      </Typography>
      <Typography variant="h8" gutterBottom className={style.itemHeader}>
        Las categorias y subcategorias inactivas no podrán ser utilizadas para
        el envío de nuevas notificaciones.{" "}
      </Typography>
    </div>
  );
}
